import React from 'react';
import { Button } from "react-bootstrap";


const StyledButton = (props) =>(
    <Button {...props}/>
);

export default StyledButton